﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aVerdensdel?: Valg<string>;
    bLand?: Valg<string>;
    cLarested?: Valg<string>;
    dHelsefag?: Valg<string>;
    eEkstraboks: boolean;
    visVilkar: boolean;
    visModal: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToggleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export interface ToggleModalAction {
    type: typeof TOGGLE_MODAL;
}

export type ValgStateActionTypes = UpdateValgAction | ToggleVilkarAction | ToggleModalAction;
